"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "FilterContextMenu" */ './lazyIndex');
});
// Delay loaded components
exports.MailFilterContextMenu = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.MailFilterContextMenu; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-list-filter-view/lib/index.js
// module id = 2325
// module chunks = 46 105